import { invoke } from '@yoda/bridge';

export async function useBridge(nameSpaceApi, params, cb) {
    try {
        const response = await invoke(nameSpaceApi, params, cb);
        response.result = response.result || 1;
        return response;
    } catch (error) {
        return { result: -1 };
    }
}

const ua = typeof window !== 'undefined' ? navigator.userAgent : '';

const APP = (function getApp() {
    // 注意顺序很重要
    const rules = [
        [/ wxwork\/(\S+)/, 'workWechat'],
        [/ MicroMessenger\/(\S+)/, 'wechat'],
        [/ Kwai\/(\S+)/, 'ks'],
        [/ ksthanos\/(\S+)/, 'ksthanos'],
        [/ ksNebula\/(\S+)/, 'ksnebula'],
        [/ ksnebula\/(\S+)/, 'ksnebula'],
        [/ACVideoCore\/(\S+)/, 'acfun'],
        [/MerchantShop\/(\S+)/, 'merchant-shop'],
        [/ QQ\/(\S+)/, 'qq'],
        [/__weibo__([^_]+)/, 'weibo'],
        [/ livemate\/(\S+)/, 'livemate'],
        [/ MQQBrowser\/(\S+)/, 'qqBrowser'],
        [/\(MSIE ([^;]+);/, 'ie'],
    ];

    for (let i = 0; i < rules.length; i++) {
        const tmp = rules[i];
        const rule = tmp[0];
        const name = tmp[1];
        const rRes = rule.exec(ua);
        if (rRes) {
            return name;
        }
    }
    return '';
}());

export const isInAcfun = APP === 'acfun';

export async function canBridgeUse(namespace, api) {
    if (isInAcfun) {
        return false;
    }
    try {
        const params = {
            namespace,
            name: api,
        };
        const nameSpaceApi = 'tool.canIUse';
        const response = await useBridge(nameSpaceApi, params);
        const { canUse } = response || {};
        return canUse;
    } catch (error) {
        return false;
    }
}


